import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { accountManagersFeatureKey, reducer } from './account-managers.reducer';
import { AccountManagersEffects } from './effects/account-managers.effects';
import { JobRecommendationEffects } from './effects/job-recommendations.effects';
import { WorkforceNotesEffects } from './effects/workforce-notes.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(accountManagersFeatureKey, reducer),
        EffectsModule.forFeature([AccountManagersEffects, WorkforceNotesEffects, JobRecommendationEffects])
    ]
})
export class AccountManagersStoreModule {}
